import { Resolvable } from './resolvable.js';
export class CalmInterface {
    constructor(uniqueId) {
        this.uniqueId = uniqueId;
    }
    static fromSchema(schema) {
        const keys = Object.keys(schema).sort();
        const isDefinition = ['config', 'definition-url', 'unique-id'].every(k => keys.includes(k));
        return isDefinition
            ? CalmInterfaceDefinition.fromSchema(schema)
            : CalmInterfaceType.fromSchema(schema);
    }
}
export class CalmInterfaceDefinition extends CalmInterface {
    constructor(originalJson, uniqueId, definitionUrl, config) {
        super(uniqueId);
        this.originalJson = originalJson;
        this.uniqueId = uniqueId;
        this.definitionUrl = definitionUrl;
        this.config = config;
    }
    toCanonicalSchema() {
        return {
            'unique-id': this.uniqueId,
            'definition-url': this.definitionUrl.reference,
            ...this.config
        };
    }
    static fromSchema(schema) {
        return new CalmInterfaceDefinition(schema, schema['unique-id'], new Resolvable(schema['definition-url']), schema.config);
    }
    toSchema() {
        return this.originalJson;
    }
}
export class CalmInterfaceType extends CalmInterface {
    constructor(originalJson, uniqueId, additionalProperties) {
        super(uniqueId);
        this.originalJson = originalJson;
        this.uniqueId = uniqueId;
        this.additionalProperties = additionalProperties;
    }
    static fromSchema(schema) {
        const { 'unique-id': uniqueId, ...additionalProperties } = schema;
        return new CalmInterfaceType(schema, uniqueId, additionalProperties);
    }
    toSchema() {
        return this.originalJson;
    }
    toCanonicalSchema() {
        return this.originalJson;
    }
}
export class CalmNodeInterface {
    constructor(originalJson, node, interfaces) {
        this.originalJson = originalJson;
        this.node = node;
        this.interfaces = interfaces;
    }
    static fromSchema(schema) {
        return new CalmNodeInterface(schema, schema.node, schema.interfaces);
    }
    toSchema() {
        return this.originalJson;
    }
    toCanonicalSchema() {
        return this.originalJson; // These are currently matching schemas
    }
}
//# sourceMappingURL=interface.js.map